/**
 * PlatformsTicker Component
 * Design: "Signal & Noise" – Dark Tech
 * Infinite scrolling ticker showing ad platforms
 * Performance: Framer Motion ersetzt durch reines CSS-Animation (transform: translateX)
 */

const platforms = [
  "Google Ads", "Meta Ads", "TikTok Ads", "LinkedIn Ads",
  "YouTube Ads", "Microsoft Advertising", "Pinterest Ads", "Snapchat Ads", "X Ads",
  "Google Analytics 4", "Google Tag Manager", "Performance Max", "Google Shopping",
  "Facebook Ads", "Instagram Ads", "Messenger Ads",
];

export function PlatformsTickerLight() {
  const doubled = [...platforms, ...platforms];

  return (
    <div className="relative py-6 overflow-hidden border-y border-slate-200" style={{ background: "#ffffff" }}>
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10" />

      <div className="ticker-track flex gap-8 whitespace-nowrap">
        {doubled.map((platform, i) => (
          <span
            key={`${platform}-${i}`}
            className="inline-flex items-center gap-2 text-sm font-sora font-medium text-slate-500"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-blue-400" />
            {platform}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function PlatformsTicker() {
  const doubled = [...platforms, ...platforms];

  return (
    <div className="relative py-6 overflow-hidden border-y border-white/5" style={{ background: "#060A12" }}>
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#060A12] to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#060A12] to-transparent z-10" />

      <div className="ticker-track flex gap-8 whitespace-nowrap">
        {doubled.map((platform, i) => (
          <span
            key={`${platform}-${i}`}
            className="inline-flex items-center gap-2 text-sm font-sora font-medium text-slate-400"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-blue-500/60" />
            {platform}
          </span>
        ))}
      </div>
    </div>
  );
}
